module.exports = __webpack_public_path__ + "281662f25034ece5c444b9d36866fe82.png";